<script>
export default {
  props: {
    image: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      defaultImg: require('@assets/images/activity_default.png'),
    }
  },
  methods: {
    onClose() {
      this.$emit('close')
    },
  }
}
</script>
<template>
  <div :class="$style['modalWrapper']">
    <header class="modal-card-head">
      <p class="modal-card-title"></p>
      <div :class="$style['modalClose']" class="delete" @click="onClose"></div>
    </header>
    <div>
      <section class="modal-card-body">
        <BaseImage :src="image" :error-src="defaultImg" class-name="is-cover" :class="$style.image" />
      </section>
    </div>
  </div>
</template>
<style lang="scss" module>
  .title {
    @extend %typography-medium;

    margin-bottom: 1rem;
    font-weight: 500;
    color: $color-primary;
    text-transform: capitalize;
  }

  .titleBox {
    margin-bottom: 5rem;
  }

  .image {
    max-width: 100%;
    max-height: calc(100vh - 140px);
  }

  .fieldNested {
    flex-wrap: wrap;
    :global(.help) {
      width: 100%;
    }
    :global(.is-expanded) {
      flex-basis: 0;
      flex-grow: 1;
      max-width: 100%;
    }
  }

  .isRequired {
    :global(.label::after) {
      margin-left: 4px;
      color: $color-danger;
      content: '*';
    }
  }

  .modalWrapper {
    display: flex;
    flex-direction: column;
    max-height: 90vh;
    text-align: center;
    background: white;
    border-radius: $size-section-border-radius;
  }

  .modalClose {
    background-color: transparent;
    &:hover {
      background-color: transparent;
    }

    &::before,
    &::after {
      background-color: $grey;
    }

    &::after {
      height: 100%;
    }

    &::before {
      width: 100%;
    }
  }
</style>
